(() => {
  'use strict';
  if (customElements.get('mokavela-product-facts')) return;

  class MokavelaProductFacts extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const link = event.target.closest('a[data-mok-size-guide]');
        if (!link || !this.contains(link)) return;
        const product = this.closest('product-info');
        const target = document.getElementById(link.hash.slice(1));
        if (!product || !target || !product.contains(target)) return;
        const details = target.querySelector('details');
        const summary = details?.querySelector('summary');
        if (!details || !summary) return;
        details.open = true;
        try {
          if (window.location.hash !== link.hash) window.history.pushState(window.history.state, '', link.hash);
        } catch (_) {
          return; // Keep the native link usable if history cannot be updated.
        }
        event.preventDefault();
        target.scrollIntoView({ block: 'start', behavior: 'auto' });
        summary.focus({ preventScroll: true });
        // Native fragment navigation can move focus back to body after this handler.
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }

  customElements.define('mokavela-product-facts', MokavelaProductFacts);
})();
